import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { ApolloClient, ApolloProvider, InMemoryCache } from '@apollo/client';
import { getConfig } from '@edx/frontend-platform';
import { getCookies } from '@edx/frontend-platform/i18n/lib';

// Minimal providers for the organisation picker: we skip the platform's
// AppWrapper so there's no sidebar / header, and — more importantly — its
// OrgCookieInitializer doesn't run here and rewrite the orgName cookie to
// the first organisation on every mount.
const OrgPageWrapper = ({ children }) => {
  const apolloClient = useMemo(() => new ApolloClient({
    cache: new InMemoryCache(),
    uri: getConfig().DDN_GRAPHQL_URL,
    credentials: 'include',
    headers: {
      'x-hasura-role': 'learner',
      'x-hasura-org-name': getCookies().get('orgName') || '',
    },
  }), []);

  return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>;
};

OrgPageWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default OrgPageWrapper;
